// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalUpdate_root__3HqHJ","footer":"ModalUpdate_footer__33pPN"};